$mol_gallery $mol_view
	sub <= items /$mol_view
	Side* $mol_gallery
		style *
			flexGrow <= side_size* \1
		items <= side_items* /$mol_view
